import { UIState } from "./interface";

const dashboardInitialState = {
	dashboardInfo: {},
	issuer: {
		email_address: "",
		first_name: "",
		last_name: "",
		logo_url: "",
		organization_name: "",
		web_address: "",
	},
	subscription: {
		subscriptions: [],
	},
	toasts: [],
};

export const UIInitialState: UIState = {
	isLoading: false,
	dashboard: dashboardInitialState,
	certificates: [],
	// communications: [],
	wizzardActiveStep: null,
	toasts: [],
	recipient: {},
};
